import React from 'react'
import { Button, Grid, Icon, Typography } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { useTranslation } from 'react-i18next'
import styles from './balance-widget.module.scss'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { formatToString } from 'utils/formatMoney'

const BalanceWidget = ({ className, collapse, minimalistic = false, small = false }) => {
  const {
    user: { balance },
  } = useSelector(({ app }) => app)
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation(['common'])

  return (
    <Grid
      className={clsx(className, styles['balance-widget'], {
        [styles['balance-widget__add-funds-button_collapse-container']]: collapse,
        [styles['balance-widget_minimalistic']]: minimalistic,
      })}
    >
      {collapse ? (
        <Button
          className={styles['balance-widget__add-funds-button']}
          component={Link}
          noWrap
          size={'m'}
          title={t('common::user_menu.add_funds')}
          variant={'primary'}
          to={pathGen(ROUTES.BILLING_TOP_UP)}
          startIcon={<Icon name={'plus'} />}
          noLabel
        />
      ) : (
        <Grid
          direction={'row'}
          justifyContent={'space-between'}
          wrap={false}
          gap={16}
        >
          <Grid
            direction={'column'}
            justifyContent={'center'}
          >
            <Typography
              variant={small ? 'Body-5' : 'Body-10'}
              color={'Label-Secondary'}
              className={styles['balance-widget__label']}
            >
              {t('common::header.balance')}
            </Typography>
            <Typography
              variant={small ? 'Body-15' : 'Body-25'}
              color={'Label-Fifth'}
              className={'balance-value'}
              component={
                <Link to={pathGen(ROUTES.FINANCE_WALLETS)}>
                  {balance && formatToString(balance.amount, balance.currency)}
                </Link>
              }
            />
          </Grid>
          <Grid
            flexDirection={'column'}
            fluid={false}
            justifyContent={'center'}
          >
            <Button
              className={styles['balance-widget__add-funds-button']}
              component={Link}
              noWrap
              size={small ? 's' : 'm'}
              title={t('common::user_menu.add_funds')}
              variant={'primary'}
              to={pathGen(ROUTES.BILLING_TOP_UP)}
              startIcon={
                <Icon
                  name={'plus'}
                  size={'sm'}
                />
              }
              noLabel
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default BalanceWidget

BalanceWidget.propTypes = {
  small: PropTypes.bool,
  minimalistic: PropTypes.bool,
  className: PropTypes.string,
  collapse: PropTypes.bool,
}
